module.exports = __webpack_public_path__ + "static/img/seriesCourses.4bf0b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seriesCourses.png
// module id = /CpG
// module chunks = 20